import * as React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import * as api from '../../../api';

import UploadDocumentPage from '../UploadDocumentPage';

interface Props extends WithTranslation {
  navigateToNextPage: () => Promise<void>;
  encounter: api.Encounter.Encounter;
  field: api.PrevisitFormField.PrevisitFormFieldWithConfig;
  setFormField: (formFieldId: string, value: string) => void;
  helpDialog: string | null;
}
interface State {
  didNotHaveCard: boolean;
}

class PhotoIdUploadPageComponent extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      didNotHaveCard: false,
    };
  }

  componentDidMount() {
    try {
      const parsed: { didNotHaveCard: boolean } = JSON.parse(
        this.props.field.value,
      );
      this.setState(parsed);
    } catch {
      this.setState({ didNotHaveCard: true });
    }
  }

  saveForm = async () => {
    const { didNotHaveCard } = this.state;
    const { field, setFormField } = this.props;
    const { id, previsitFormSetId } = field;

    const newValue = JSON.stringify({ didNotHaveCard });
    setFormField(id, newValue);
    await api.client.Previsit.updateFormField(previsitFormSetId, id, newValue);
  };

  handleSetPhotoId = async (didNotHaveCard: boolean) => {
    const { navigateToNextPage } = this.props;

    this.setState({ didNotHaveCard }, async () => {
      await this.saveForm();
      await navigateToNextPage();
    });
  };

  render() {
    const { t } = this.props;
    return (
      <UploadDocumentPage
        navigateToNextPage={this.handleSetPhotoId}
        label={t(
          `Upload photos of the driver's license or government ID for the subscriber.`,
        )}
        labelReview={t(
          'Review the Photo ID we have on file. Is this ID still valid?',
        )}
        labelHasChanged={t('No, my ID has changed')}
        type="Driver's License"
        helpDialog={this.props.helpDialog}
        continueLabel={t('Continue')}
        documentType={api.PatientUpload.DocumentType.PhotoID}
        encounter={this.props.encounter}
        required={this.props.field.required}
        showEditTool={true}
      />
    );
  }
}

export const PhotoIdUploadPage = withTranslation()(PhotoIdUploadPageComponent);
